import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../store";
import { isAuthRoute } from "../../common/util/routeUtils";
import defaultContent from "../../content/impersonationBanner";
import "./ImpersonationBanner.scss";

export const ImpersonationBanner = () => {
  const { t } = useTranslation(["impersonationBanner"]);
  const { pathname } = useLocation();
  const { isImpersonation, configuration, user } = useAppSelector((state) => state.boot);
  const { showImpersonationBanner } = configuration;
  const { abo, aff } = user;

  if (!isImpersonation || !showImpersonationBanner || isAuthRoute(pathname)) {
    return null;
  }

  return (
    <div className="ImpersonationBanner" role="alert" data-testid="impersonation-banner">
      <span className="ImpersonationBanner__message">{t("message", defaultContent.message)}</span>
      <span className="ImpersonationBanner__aboInfo" data-testid="impersonation-banner-abo-info">
        <span className="ImpersonationBanner__aboInfo__item">
          <span className="ImpersonationBanner__aboInfo__label">{t("aboLabel", defaultContent.aboLabel)}:</span>
          {` ${abo}`}
        </span>
        <span className="ImpersonationBanner__aboInfo__item">
          <span className="ImpersonationBanner__aboInfo__label">{t("affLabel", defaultContent.affLabel)}:</span>
          {` ${aff}`}
        </span>
      </span>
    </div>
  );
};
